import React from 'react';

const S360WidgetContainer = ({style, children}) =>
{
    return <div className='widget widget-2' style={style}>
        { children }
    </div>
}

export default S360WidgetContainer ;